import React, {createElement} from 'react';
import {ReactComponent as accessibility}
    from '../../../assets/icons/lines/system-accesibilitat.svg';
function InfoWindow(props: any) {
    const data = props.value;

    return (
        <>
            <span className="accessibility">
                {props.accessibility ? createElement(accessibility):''}
            </span>
            <h3>{data.name}</h3>
        </>
    );
}

export default InfoWindow;
